import React from "react";
import CommunityLayout from "../../components/Community/CommunityLayout";

const CommunityHomePage = () => {
  return (
    <CommunityLayout>
      <h1>Welcome to the Community Home Page</h1>
      <p>Explore rooms, sections, and more.</p>
    </CommunityLayout>
  );
};

export default CommunityHomePage;
